"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticEventHandler = (function () {
    function AnalyticEventHandler() {
    }
    AnalyticEventHandler.logEvent = function (event, data) {
        if (!window.analyticEventListeners) {
            window.analyticEventListeners = {};
        }
        Object.values(window.analyticEventListeners).forEach(function (listener) {
            if (listener) {
                listener(event, data);
            }
        });
    };
    return AnalyticEventHandler;
}());
exports.default = AnalyticEventHandler;
//# sourceMappingURL=AnalyticEvents.js.map